<template>
	<div id="pagination" style="text-align: center;">
		<div class="btn prve" @click="btnChange('prve')" v-if="page > 1" ><</div>
		<div class="btn num" @click="btnChange(item)" :class="page == item?'active':''" v-for="item in totalPage">{{item}}</div>
		<div class="btn next" @click="btnChange('next')" v-if="page < totalPage" >></div>
	</div>
</template>

<script>
	export default {
		props:{
			currentPage:{
				type:Number,
				default:1
			},
			pageSize:{
				type:Number,
				default:10
			},
			total:{
				type:Number
			}
		},
		data:function() {
			return {
				page:this.currentPage,
				totalPage:new Array()
			};
		},
		mounted(){
			var num;
			setTimeout(()=>{
				num = parseInt(this.total / this.pageSize)
				if(num > 0){
					for(var i =0;i<=num;i++){
						this.totalPage.push(i+1)
					}
				}else{
					this.totalPage.push(1)
				}
			},500)
		},
		methods:{
			btnChange(e){
				if(e == 'prve'){
					this.page--
				}else if(e == 'next'){
					this.page++
				}else{
					this.page = e
				}
				this.$emit('getPage',this.page)
			}
		}
	}
</script>

<style lang="scss">
	#pagination{
		.btn{
			display: inline-block;
			width:40px;
			height:40px;
			text-align: center;
			line-height:40px;
			box-sizing: border-box;
			font-size:18px;
			color:#777777;
			border: 1px solid #dadada;
			background:#FFF;
			margin:0 6px;
			cursor: pointer;
			&.active,&:hover{
				color:#FFF;
				background:#124098;
			}
		}
	}
</style>
